import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../public/styles/main.css';

interface UserProfileProps {
    displayName: string;
    photoURL?: string;
}

export default function UserProfile({ displayName, photoURL }: UserProfileProps) {
    const navigate = useNavigate();

    const initial = displayName ? displayName.charAt(0).toUpperCase() : 'U';

    const handleClick = () => {
        navigate('/profile');
    };

    return (
        <div className="user-profile" onClick={handleClick}>
            <span className="user-profile-name">{displayName}</span>
            <div className="user-profile-avatar">
                {photoURL ? (
                    <img src={photoURL} alt={displayName} className="user-avatar-img" />
                ) : (
                    <div className="user-avatar-placeholder">
                        {initial}
                    </div>
                )}
            </div>
        </div>
    );
}
